<template>
  <div class="row  items-center">
    <!-- <div style="display: inline-block" class="text-h6">Draw Lanes</div> -->

    <!-- <q-tabs
      v-if="!finalsProgressionSection && !placingsProgressionSection"
      v-model="round_id"
    >
      <q-tab
        :name="'registration'"
        label="Registration"
        class="text-white"
        :class="{
          'bg-positive': true,
          'bg-primary': false,
        }"
      />
      <q-tab
        :name="'drawLanes'"
        label="Draw Lanes"
        class="text-white"
        :class="{
          'bg-positive': true,
          'bg-primary': false,
        }"
      />
      <q-tab
        v-for="(round, index) in eventRounds"
        :key="`tab_${index}`"
        :name="round.id"
        :label="
          round.round_name == 'Final 1'
            ? 'Final'
            : round.round_name == 'Heats 1'
            ? 'Heats'
            : round.round_name
        "
        class="text-white"
        :class="{
          'bg-positive': round.roundFinished_at,
          'bg-primary': !round.roundFinished_at,
        }"
      />
    </q-tabs>
    <div
      v-if="
        showFinalsProgressionButton &&
        !finalsProgressionSection &&
        !placingsProgressionSection &&
        ((event.combinedEvents &&
          event.combinedEvents.length != 0 &&
          currentRound.races &&
          currentRound.races[0].ce_overallFinal != 1) ||
          (currentRound &&
            currentRound.round_name != 'Final' &&
            currentRound.round_name != 'Final 1')) &&
        eventRounds &&
        eventRounds[eventRounds.length - 1] &&
        eventRounds[eventRounds.length - 1].id == round.id
      "
      class="q-px-md"
    >
      <q-btn
        v-if="showFinalsProgressionButton && !finalsProgressionSection"
        @click="finalsProgressionSection = true"
        class="bg-primary text-white"
        no-caps
      >
        Next Stage
      </q-btn>
    </div> -->

    <div
      v-if="round && !finalsProgressionSection && !placingsProgressionSection"
      class="col-12"
    >
      <round
        :round="round"
        @changeCurrentView="val => (currentRoundView = val)"
      />
    </div>
    <div v-if="finalsProgressionSection" class="col-12">
      <finalsProgression @close="$emit('closeFinalsProgressionSection')" />
    </div>
    <div v-if="placingsProgressionSection" class="col-12">
      <placings @close="$emit('closePlacingsProgressionSection')" />
    </div>
    <div class="q-px-md full-width" style="z-index: 2">
      <q-btn
        @click="resetFinalsProgression"
        class="bg-grey text-white"
        no-caps
        :loading="resettingFinalsProgression"
        dense
        v-if="
          currentRound.generatedFromNextProgression == 1 &&
            !finalsProgressionSection &&
            !placingsProgressionSection &&
            !currentRoundView
        "
      >
        Reset to Previous Stage
      </q-btn>
      <q-btn
        v-if="
          showFinalsProgressionButton &&
            !finalsProgressionSection &&
            currentRound &&
            (currentRound.round_name == 'Final' ||
              currentRound.round_name == 'Final 1') &&
            (!event.combinedEvents ||
              event.combinedEvents.length == 0 ||
              (currentRound.races &&
                currentRound.races[0].ce_overallFinal == 1)) &&
            showFinalsProgressionButton &&
            !finalsProgressionSection &&
            !placingsProgressionSection &&
            !currentRoundView
        "
        @click="finishEvent"
        class="bg-primary text-white float-right"
        no-caps
        :loading="finishingEvent"
        dense
      >
        Finish Event
      </q-btn>
    </div>
    <div class="q-px-md full-width text-right" style="z-index: 2"></div>
    <div class="q-px-md full-width text-left" style="z-index: 2"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import round from "@/components/wavesProgress/round.vue";
import finalsProgression from "@/components/wavesProgress/finalsProgression.vue";
import placings from "@/components/wavesProgress/placings.vue";

// import { Notify } from "quasar";

export default {
  components: { round, finalsProgression, placings },
  props: {
    round_id: {
      default: null
    },
    round: {
      default: null
    },
    finalsProgressionSection: {
      default: false
    },
    placingsProgressionSection: {
      default: false
    },
    currentRound: {
      default: null
    },
    showFinalsProgressionButton: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      siteCFG: "settings/siteCFG",
      registeredParticipants: "events/registeredParticipants",
      event: "events/current",
      eventRounds: "eventProgress/rounds"
      // currentRound: "eventProgress/currentRound",
    })
  },
  data: () => ({
    // round_id: null,
    // round: null,
    // showFinalsProgressionButton: false,
    // finalsProgressionSection: false,
    // placingsProgressionSection: false,
    currentRoundView: null,

    finishingEvent: false,
    resettingFinalsProgression: false
  }),
  watch: {
    // round_id: function () {
    //   if (this.round_id) {
    //     this.round = this.eventRounds.find((e) => e.id == this.round_id);
    //   } else {
    //     this.round == null;
    //   }
    // },
    // eventRounds: function () {
    // this.checkIfProgressionAvailable();
    // },
  },
  mounted() {
    // this.$store.dispatch("eventProgress/loadRounds", this.event.id).then(() => {
    //   if (this.eventRounds.length < 1) {
    //     setTimeout(() => {
    //       this.$store
    //         .dispatch("eventProgress/loadRounds", this.event.id)
    //         .then(() => {
    //           this.initRoundData();
    //         });
    //     }, 500);
    //   } else {
    //     this.initRoundData();
    //   }
    // });
    // this.$store.dispatch("dqCodes/loadAll");
    // this.checkIfProgressionAvailable();
  },
  methods: {
    // initRoundData() {
    //   let round = this.eventRounds.find((e) => e.roundFinished_at == null);

    //   this.round_id = round
    //     ? round.id
    //     : this.eventRounds && this.eventRounds[this.eventRounds.length - 1]
    //     ? this.eventRounds[this.eventRounds.length - 1].id
    //     : null;

    //   this.round = round
    //     ? round
    //     : this.eventRounds && this.eventRounds[this.eventRounds.length - 1]
    //     ? this.eventRounds[this.eventRounds.length - 1]
    //     : null;

    //   this.checkIfProgressionAvailable();
    // },
    // checkIfProgressionAvailable() {
    //   let finished = 0;
    //   this.eventRounds.forEach((round) => {
    //     if (round.roundFinished_at) {
    //       finished += 1;
    //     }
    //   });

    //   if (finished == this.eventRounds.length) {
    //     this.showFinalsProgressionButton = true;
    //   } else {
    //     this.showFinalsProgressionButton = false;
    //   }
    // },
    async resetFinalsProgression() {
      let warning = await this.$swal({
        title: "Warning",
        text:
          "You are about to reset the event to the previous round, this will be irreversible and you will loose any data on this screen",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122"
      });

      if (warning.value) {
        this.resettingFinalsProgression = true;
        try {
          let response = await this.$store.dispatch(
            "eventProgress/resetFinalsProgression",
            {
              round_id: this.currentRound.id,
              event_id: this.currentRound.events_id
            }
          );
          this.$emit("enterPreviousRound");
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: "The event has been finished"
          });
        } catch (error) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an error finishing the event"
          });
        }
        this.resettingFinalsProgression = false;
      }
    },
    async finishEvent() {
      this.finishingEvent = true;
      try {
        let response = await this.$store.dispatch(
          "eventProgress/submitPlacings",
          this.event.id
        );
        this.$router.push(`${this.$route.path.split("/events")[0]}/events`);
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: "The event has been finished"
        });
      } catch (error) {
        console.log(error);
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error finishing the event"
        });
      }
      this.finishingEvent = false;
    }
  }
};
</script>
